/**
 * Pré-configuração do modo demo — centraliza os "roteiros" apresentados ao
 * professor logo após o login/refresh, para facilitar reset e ajustes futuros.
 *
 * Quando `resetDemoAndReload` é disparado, as chaves de sessão listadas em
 * `resetDemo.js` são limpas, fazendo com que os avisos voltem a aparecer.
 */

/** Turma vinculada a plano de aula, calendário e ocorrências. */
export const DEMO_SCENARIO_CLASS_ID = "DEMO-T1";

/** Communication.id da ciência obrigatória (ver `buildDemoCommunicationDetail.js`). */
export const DEMO_ACK_COMMUNICATION_ID = 6;

/**
 * Cenário inicial apresentado ao abrir o sistema em modo demo.
 * - `forceAckOnOpen`: reabre o `AckDialog` a cada refresh (até o professor confirmar).
 * - `showAckNotification`: gera a notificação "Requer ciência" no sino, sincronizada
 *                          com o estado do `AckDialog` (some após ciência).
 */
export const DEMO_SCENARIO = {
  forceAckOnOpen: true,
  showAckNotification: true,
  /**
   * Perfil do aluno: força “aula em andamento” + próxima aula no roteiro demo,
   * independente do relógio real (para funcionários verem o destaque).
   */
  forceLiveClassOnStudentProfile: true,
  /**
   * Relatório individual:
   * - `seedExistingReport`: se `true`, a lista (`IndividualReportList`) apresenta
   *    pelo menos um relatório pré-preenchido para a turma demo (1º bimestre).
   */
  individualReport: {
    seedExistingReport: true
  },
  /**
   * Resumo diário (template demo, educação infantil):
   * - `seedExistingSummaries`: se `true`, a lista (`DailySummaryList`) apresenta
   *    resumos pré-preenchidos para hoje (todos os momentos) + ontem (almoço).
   */
  dailySummary: {
    seedExistingSummaries: true
  }
};

/**
 * Id/subscriberId fixos para a notificação dinâmica de "ciência obrigatória" no sino
 * (mantidos acima dos ids fixos das demais notificações demo para evitar colisão).
 */
export const DEMO_ACK_NOTIFICATION_ID = 9101;
export const DEMO_ACK_SUBSCRIBER_ID = 9101;
